// Interface to decouple from core entities
export type MerchantWithCountry = {
  country?: string;
};

// Mapping of country codes to their timezones
const COUNTRY_TIMEZONE_MAP: Record<string, string> = {
  CO: "America/Bogota", // Colombia
  DO: "America/Santo_Domingo", // Dominican Republic
};

const DEFAULT_COUNTRY = "CO";
const DEFAULT_TIMEZONE = COUNTRY_TIMEZONE_MAP[DEFAULT_COUNTRY];

/**
 * Determines the country from merchant data with fallback to default (CO)
 */
export const getCountryFromMerchant = (merchant: MerchantWithCountry): string => {
  return merchant.country || DEFAULT_COUNTRY;
};

/**
 * Gets the timezone for a given country code
 */
export const getTimezoneForCountry = (countryCode: string | undefined): string => {
  if (!countryCode) {
    return DEFAULT_TIMEZONE;
  }
  return COUNTRY_TIMEZONE_MAP[countryCode] || DEFAULT_TIMEZONE;
};

/**
 * Determines the timezone based on merchant data
 */
export const getTimezoneFromMerchant = (merchant: MerchantWithCountry): string => {
  const country = getCountryFromMerchant(merchant);
  return getTimezoneForCountry(country);
};

/**
 * Gets the country code and timezone for holidays and time calculations
 */
export const getCountryAndTimezone = (
  merchant: MerchantWithCountry
): { country: string; timezone: string } => {
  const country = getCountryFromMerchant(merchant);
  const timezone = getTimezoneForCountry(country);

  return { country, timezone };
};
